import React from "react";
import { Paper, Typography } from "@mui/material";
import { BRAND_COLOR } from "./constants";

export interface StatItemProps {
  title: string;
  value: string | number;
  testId?: string;
}

export const StatItem: React.FC<StatItemProps> = ({ title, value, testId }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      height: "100%",
      backgroundColor: "#fff",
      border: "1px solid #e8e8e8",
      borderRadius: 1.5,
      transition: "all 0.15s ease",
      "&:hover": {
        borderColor: BRAND_COLOR,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      },
    }}
    data-testid="statistics-category-item"
  >
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ fontWeight: 500, fontSize: "0.75rem", display: "block", mb: 0.5 }}
      data-testid={testId ? `${testId}-name` : "statistics-category-item-name"}
    >
      {title}
    </Typography>
    <Typography
      variant="h4"
      sx={{ color: BRAND_COLOR, fontWeight: 600, fontSize: "1.75rem" }}
      data-testid={
        testId ? `${testId}-count` : "statistics-category-item-count"
      }
    >
      {value}
    </Typography>
  </Paper>
);
